import {
    Grid,
    useTheme,
    useMediaQuery
} from '@mui/material'

import Projects from './Projects';
import HideForms from '../../../components/SendPulseForms/hide';



const ProjectsLayout = () => {
    const theme = useTheme();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));


    return (
        <>
            <HideForms />
            <Grid container columns={{ xs: 4, md: 5, lg: 12 }} spacing={0} sx={{ mt: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "43px", lg: "120px" } }}>
                {(isXl || isLg) && <Projects rowsPerPage={10} />}
                {isMd && <Projects rowsPerPage={5} />}
                {isXs && <Projects rowsPerPage={4} />}
            </Grid>
        </>
    )
}

export default ProjectsLayout